// A fern: low, no trunk — a rosette of long thin fronds arching out from the
// ground. Ported 1:1 from age-of-mcp's classic tree-fern.ts, restoring its
// radial frond loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  const N = 7;
  for (let i = 0; i < N; i++) {
    const a = (i / N) * Math.PI * 2;
    parts.push({
      geometry: new THREE.BoxGeometry(0.55, 0.03, 0.14),
      color: i % 2 ? "#3c7a34" : "#4b9440",
      position: [Math.cos(a) * 0.24, 0.22, Math.sin(a) * 0.24],
      rotation: [0, -a, -0.5],   // arch up then out
    });
  }
  parts.push({ geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#356b2f",
    position: [0, 0.08, 0] });
  return parts;
}

export const treeFern = defineModel({
  id: "tree-fern",
  batchId: "standard",
  name: "Tree fern",
  tags: ["scenery","tree","fern","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree fern.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.38,
  parts: () => partsFor(),
  animations: [],
});
